import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { useState } from "react";
import Header from "../home/header";
import UTILS from "../../utils/commons";
import { ApiClient } from "../../utils/api-client";

import Loading from "../home/Loading";
import PaginationControl from "../home/pagination_control";
import ExpenseItem from "./expenses_item";

const Expenses = () => {
    var navigate = useNavigate();
    var loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
    const [ expenses, setExpenses ] = useState( [] );
    const [ filteredData, setFilteredData ] = useState( expenses );
    const [ loading, setLoading ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( 10 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );

    const search = ( e ) => {
        let keyword = e.target.value.trim().toLowerCase();
        let result = expenses;
        if ( keyword.length > 0 ) {
            result = expenses.filter( d => d.account.name.toLowerCase().includes( keyword ) || d.date.toLowerCase().includes( keyword ) || d.owner.fname.toLowerCase().includes( keyword ) || d.owner.lname.toLowerCase().includes( keyword ) );
        }
        setFilteredData( result );
    }
    const handlePageChange = ( newPage ) => {
        setCurrentPage( newPage );
        loadData();
    }
    const handlePageSizeChange = ( newPageSize ) => {
        setPageSize( newPageSize );
        setCurrentPage( 1 );
        loadData();
    }
    const loadData = async () => {
        const endpoint = "/payments/paginated";
        const params = { page: currentPage, limit: pageSize, type: 2 };
        if ( loginState.role == UTILS.ADMIN ) params.ownerId = loginState.id;
        else params.profileId = loginState.profile.id;
        const response = await apiClient.get( endpoint, { params: params } )

        if ( response.status === 200 && response.data ) {
            setExpenses( response.data.data );
            setFilteredData( response.data.data );
            setTotalPages( response.data.totalPages );
            setHasNextPage( response.data.hasNextPage );
            setHasPreviousPage( response.data.hasPreviousPage );
        }
        else if ( response.status === 401 ) {
            UTILS.signout();
            navigate( '/signin', { replace: true, target: '/expenses' } );
        }
    }
    useEffect( () => {
        loadData();
    }, [] )
    return ( <>
            <Header auth={loginState} />
            <section className="flex justify-start items-start">
                <div className="container">
                    <div className="md:flex justify-between bg-gray-100 p-4 rounded-md">
                        <p className="large-text">Expenses</p>
                        <button className="btn bg-success" onClick={() => navigate( "/expenses/new", { replace: false } )}>Add</button>
                    </div>
                    {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                        <div className="mt-12">{filteredData.length > 0 ? <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} /> : null}
                            <div className="border-t-2 pt-4 grid md:grid-cols-1 gap-2 md:justify-start md:items-center flex-wrap" id="list_container">
                                <div className="grid md:grid-cols-5 bg-gray-200 p-2 font-bold ">
                                    <span>Date</span>
                                    <span>Category</span>
                                    <span>Amount</span>
                                    <span>Paid To</span>
                                    <span>Reason</span>
                                    {/* <span className="text-center">Recorded By</span> */}
                                </div>
                                {filteredData && filteredData.length > 0 ? filteredData.map( ( r, i ) => {
                                    return <ExpenseItem data={r} key={r.id} source={expenses} />
                                } ) : <span className="text-center w-full">No data</span>
                                }
                            </div>
                        </div>
                    )}</div>

            </section>
        </> )
   
}
export default Expenses;